
import React from "react";
import { Link, NavLink } from "react-router-dom";

import {
  HiOutlineSquares2X2,
  HiOutlineArrowUpRight,
  HiOutlineXMark,
} from "react-icons/hi2";

import { navItems } from "../../constants";

function Navmobile({
  active,
  DropActive,
  language = "ar",
  accountPath = "/Login",
  accountLabel,
  AccountIcon = HiOutlineSquares2X2,
  onClose,
}) {
  const isArabic = language === "ar";

  const handleNavigate = () => {
    onClose?.();
    window.scrollTo(0, 0);
  };

  return (
    <div
      id="mobile-site-navigation"
      className="
        fixed inset-x-0 bottom-0
        top-[76px] z-[100]
        xl:hidden
      "
    >
      {/* Clickable background */}
      <button
        type="button"
        tabIndex={-1}
        aria-label={
          isArabic
            ? "إغلاق القائمة"
            : "Close menu"
        }
        onClick={onClose}
        className="
          absolute inset-0
          h-full w-full
          bg-[#071522]/50
          backdrop-blur-[5px]
        "
      />

      {/* Floating panel */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={
          isArabic
            ? "القائمة الرئيسية"
            : "Main menu"
        }
        className="
          absolute inset-x-3 top-3
          max-h-[calc(100%-24px)]
          overflow-y-auto
          rounded-[22px]
          border border-skin-border
          bg-skin-surface/95
          p-4
          shadow-[0_25px_70px_rgba(0,0,0,0.20)]
          backdrop-blur-2xl

          dark:border-white/10
          dark:bg-[#102031]/95

          sm:inset-x-auto
          sm:end-6
          sm:w-[390px]
          sm:p-5
        "
      >
        {/* Panel title */}
        <div className="mb-5 flex items-center justify-between border-b border-skin-border pb-4">

          <div>
            <h2 className="h6 text-skin-heading">
              {isArabic
                ? "القائمة الرئيسية"
                : "Main Menu"}
            </h2>

            <p className="caption mt-1 text-skin-muted">
              {isArabic
                ? "استكشف أقسام الموقع"
                : "Explore our website"}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label={
              isArabic ? "إغلاق" : "Close"
            }
            className="
              flex h-10 w-10
              items-center justify-center
              rounded-xl
              bg-skin-soft
              text-skin-heading
              transition-colors
              hover:bg-skin-raised
            "
          >
            <HiOutlineXMark
              size={21}
              aria-hidden="true"
            />
          </button>
        </div>

        {/* Navigation links */}
        <nav
          aria-label={
            isArabic
              ? "روابط الموقع"
              : "Site links"
          }
          className="flex flex-col gap-2"
        >
          {navItems.map((item, index) => (
            <NavLink
              key={item.id ?? item.link ?? index}
              to={item.link}
              end={item.link === "/"}
              onClick={handleNavigate}
              className={({ isActive }) => {
                const selected =
                  isActive ||
                  active === index + 1;

                return `
                  group flex min-h-[52px]
                  items-center justify-between
                  gap-4 rounded-xl
                  border px-4 py-3
                  transition-colors duration-200

                  ${
                    selected
                      ? "border-skin-accent/30 bg-skin-soft text-skin-heading"
                      : "border-transparent text-skin-text hover:border-skin-border hover:bg-skin-soft"
                  }
                `;
              }}
            >
              {({ isActive }) => {
                const selected =
                  isActive ||
                  active === index + 1;

                return (
                  <>
                    <div className="flex items-center gap-3">
                      <span
                        className={`
                          h-1.5 w-1.5
                          shrink-0 rounded-full
                          ${
                            selected
                              ? "bg-skin-accent"
                              : "bg-skin-border"
                          }
                        `}
                      />

                      <span className="h7">
                        {language === "en"
                          ? item.titleEn
                          : item.titleAr}
                      </span>
                    </div>

                    <HiOutlineArrowUpRight
                      size={17}
                      aria-hidden="true"
                      className={
                        selected
                          ? "text-skin-accent"
                          : "text-skin-muted"
                      }
                    />
                  </>
                );
              }}
            </NavLink>
          ))}
        </nav>

        {/* Account */}
        <div className="mt-5 border-t border-skin-border pt-5">
          <Link
            to={accountPath}
            onClick={handleNavigate}
            className="
              group flex min-h-[54px]
              items-center justify-between
              gap-3 rounded-xl
              border border-skin-border
              bg-skin-soft/90
              px-4 py-3
              text-skin-heading
              transition-colors duration-200

              hover:bg-skin-raised

              dark:border-white/15
              dark:bg-white/[0.08]
              dark:text-white
              dark:hover:bg-white/[0.14]
            "
          >
            <span className="flex items-center gap-3">
              <AccountIcon
                size={21}
                aria-hidden="true"
                className="text-skin-accent"
              />

              <span className="button-sm">
                {accountLabel}
              </span>
            </span>

            <HiOutlineArrowUpRight
              size={19}
              aria-hidden="true"
              className="text-skin-muted"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Navmobile;
